export const ALLOWED_EXTERNAL_URL_SCHEMES = new Set(['http:', 'https:']);
